<template>
  <div class="ai">
    <!-- <div class="content">敬请期待</div> -->
    <button @click="comName='UserName'">账号密码填写</button>
    <button @click="comName = 'UserInfo'">个人信息填写</button>
    <div>
      <!-- <keep-live> -->
        <component :is="comName"></component>
      <!-- </keep-live> -->
    </div>
  </div>
</template>

<script>
import UserName from '@/views/Ai/components/UserName.vue'
import UserInfo from '@/views/Ai/components/UserInfo.vue'
export default {
  data() {
    return {
      comName:"UserName"
    }
  },
  components:{
    UserName,
    UserInfo
  },
  created(){
    console.log("创建");
  },
  destroyed(){
    console.log("销毁");
  },
  activated(){
    console.log("激活");
  },
  deactivated(){
    console.log("失去激活");
  }
}
</script>

<style lang="scss" scoped>
.ai{
  padding-top: 70px;
  .content{
    padding-top: 200px;
    height: 500px;
    text-align: center;
    font-size: 16px;
  }
}
</style>
